type Props = {
  height?: number;
  stroke?: string;
  width?: number;
};

export default function ShieldIcon({
  stroke = '#FFAA00',
  height = 32,
  width = 32
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.06883 9.15802L6.21973 12.08C6.54068 18.4087 10.2455 24.1274 15.9998 27.1566C21.7504 24.1274 25.4559 18.4085 25.7803 12.0789L25.9312 9.15802C21.665 8.38101 18.1395 6.42813 16 4.99367C13.8605 6.42813 10.335 8.38101 6.06883 9.15802ZM27.9995 7.88719L27.7777 12.1813C27.4027 19.4961 22.9795 26.0431 16.2218 29.2832C16.0806 29.3498 15.9153 29.3498 15.7782 29.2832C9.01644 26.0431 4.59326 19.4961 4.2223 12.1813L4.00054 7.88719C3.98845 7.62861 4.18198 7.40529 4.44809 7.37786C9.50837 6.79798 13.6694 4.23956 15.6976 2.7664C15.879 2.6332 16.121 2.6332 16.3024 2.7664C18.3306 4.23956 22.4916 6.79798 27.5519 7.37786C27.818 7.40529 28.0115 7.62861 27.9995 7.88719ZM16.6525 27.4844L16.6425 27.4796L16.6525 27.4844Z"
        fill={stroke}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8132 12.2233C22.1317 12.5296 22.1416 13.036 21.8354 13.3545L14.9978 20.4656C14.8491 20.6203 14.6445 20.7087 14.4299 20.7111C14.2154 20.7134 14.0089 20.6295 13.8568 20.4782L10.9022 17.538C10.589 17.2264 10.5878 16.7198 10.8994 16.4066C11.2111 16.0935 11.7176 16.0922 12.0308 16.4039L14.4085 18.77L20.682 12.2455C20.9883 11.927 21.4947 11.9171 21.8132 12.2233Z"
        fill={stroke}
      />
    </svg>
  );
}
